import React from "react";
import PanelHead from "../../Panel/PanelHead";
import PanelBody from "../../Panel/PanelBody";
import { FormAddFaq } from "./FormAddFaq";

export const PanelAddFaq = () => {
  return (
    <div>
      {" "}
      <PanelHead
        title={
          <div className="flex items-center justify-between w-full gap-4">
            <div>Add Faq</div>
          </div>
        }
      />
      <PanelBody content={<FormAddFaq />} />
    </div>
  );
};
